/* src/app/cl-link/cl-link.component.scss */
.links {
  background: white;
  color: black;
  height: 100%;
  padding: 150px 200px;
  font-family: "Campton-Light";
  text-align: left;
  overflow-wrap: anywhere;
  font-size: 21px;
}
.links img {
  margin: 14px 0 50px;
}
.links ul {
  list-style-position: outside;
  margin-bottom: 1rem;
  margin: 0px;
  padding: 0px;
  margin-left: 1.25rem;
  margin-top: 1rem;
}
.links p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.6;
  text-rendering: optimizeLegibility;
}
.links h1 {
  font-size: 56px;
  line-height: 1.29;
  letter-spacing: 0.8px;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  font-weight: 700;
  font-family: "Campton-Bold";
}
.links ::ng-deep a {
  color: blue !important;
}
.links ::ng-deep a:hover {
  text-decoration: underline;
  text-decoration-style: dashed;
}
.links .dash {
  display: inline-block;
  width: 80px;
  height: 8px;
  padding: 0;
  margin: 0 0 24px;
  line-height: 8px;
}
.links .pressDash {
  background-color: #ff495c;
}
.links .newsDash {
  background-color: #d1a66f;
}
.links .buttons {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
/*# sourceMappingURL=cl-link.component.css.map */
